import { combineEpics, type Epic } from 'redux-observable';
import famaErrorHandlerEpicMiddleware from '@atlassian/jira-errors-handling/src/utils/fama-epic-wrapper.tsx';
import { PACKAGE_NAME } from '../model/constants.tsx';
import type { ServiceDependencies } from '../services/types.tsx';
import type { Action } from '../state/actions.tsx';
import type { State } from '../state/types.tsx';
import fetchAvatarsEpic from './fetch-avatars/index.tsx';
import saveAvatarImageEpic from './save-avatar-image/index.tsx';

const epic = combineEpics(fetchAvatarsEpic, saveAvatarImageEpic);

export const rootOperation: Epic<Action, State> = famaErrorHandlerEpicMiddleware<
	State,
	Action,
	ServiceDependencies
>({
	packageName: PACKAGE_NAME,
	id: 'epic',
	epic,
	sendToPrivacyUnsafeSplunk: true,
});
